import { render, staticRenderFns } from "./SetAiBusinessPromoterInfo.vue?vue&type=template&id=6ab93e96&scoped=true&"
import script from "./SetAiBusinessPromoterInfo.vue?vue&type=script&lang=js&"
export * from "./SetAiBusinessPromoterInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetAiBusinessPromoterInfo.vue?vue&type=style&index=0&id=6ab93e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab93e96",
  null
  
)

export default component.exports